var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tabList.length)?_c('div',{staticClass:"mobile-tab"},_vm._l((_vm.tabList),function(item,index){return _c('span',{key:index,class:_vm.activeValue == item.value && 'tab-active',on:{"click":function($event){return _setup.handleTabChange(item)}}},[_vm._v(_vm._s(item.label))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }